<div class="modal-content">
  <div class="{{ title ? 'modal-header' : '' }}">
    <h4 *ngIf="title" class="modal-title d-inline-block align-middle">{{ title }}</h4>
    <button type="button" class="close pull-right align-middle {{ title ? '' : 'mt-2' }}" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!isAlert" class="text-center">
      <jhi-bary-icon *ngIf="icon" [icon]="icon" size="4x" [class]="class"></jhi-bary-icon>
      <p class="lead pt-4" [innerHTML]="message"></p>
    </div>
    <div *ngIf="isAlert" class="alert alert-danger d-flex flex-row align-items-center">
      <jhi-bary-icon *ngIf="icon" [icon]="icon" size="4x" [class]="class"></jhi-bary-icon>
      <p class="lead pt-4 text-center" [innerHTML]="message"></p>
    </div>
  </div>
  <div class="modal-footer flex-column flex-md-row justify-content-center">
    <jhi-bary-button
      (clickEvent)="handleClick({ second: true })"
      *ngIf="buttons.second"
      [label]="buttons.second"
      color="primary"
      class="mb-2 mb-sm-0 mr-0 mr-sm-2"
    ></jhi-bary-button>
    <jhi-bary-button
      *ngIf="buttons.submit"
      [block]="!buttons.second"
      [outline]="true"
      [label]="buttons.submit"
      (clickEvent)="handleClick({ submit: true })"
      data-id-cypress="modal-confirm"
    ></jhi-bary-button>
  </div>
</div>
